import { useQuery } from "@tanstack/react-query";
import { TrendingUp } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import api from "@/lib/api";
import { SectionCard, EmptyState } from "@/components/Common";
import { formatRupiah } from "@/lib/format";

const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const COLORS = ["#dd6030", "#0369a1", "#7e22ce", "#047857", "#c2410c", "#0891b2"];
const monthLabel = (m) => { const [y, mo] = String(m).split("-"); return `${BULAN[Number(mo) - 1] || mo} ${String(y).slice(2)}`; };
const compactRp = (v) => (v >= 1e6 ? `${(v / 1e6).toFixed(1)}jt` : v >= 1e3 ? `${Math.round(v / 1e3)}rb` : `${v}`);

export function ParkingTrend({ projectParam, projectId }) {
  const { data } = useQuery({
    queryKey: ["pk-trend", projectId],
    queryFn: async () => (await api.get("/parking/trend", { params: { ...projectParam, months: 6 } })).data,
  });
  const series = data?.series || [];
  const rows = data?.data || [];
  const empty = !rows.some((r) => r.total > 0);
  return (
    <SectionCard title="Tren Pendapatan Parkir" description="Pendapatan parkir per proyek, 6 bulan terakhir (berdasarkan tanggal bayar)." testid="pk-trend-section">
      {empty ? (
        <EmptyState title="Belum ada data tren" description="Grafik muncul setelah ada pembayaran sewa parkir." icon={TrendingUp} />
      ) : (
        <div className="h-72 w-full" data-testid="pk-trend-chart">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
              <XAxis dataKey="month" tickFormatter={monthLabel} tick={{ fontSize: 12 }} />
              <YAxis tickFormatter={compactRp} tick={{ fontSize: 12 }} width={56} />
              <Tooltip formatter={(v, n) => [formatRupiah(v), n]} labelFormatter={monthLabel} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {series.map((s, i) => (
                <Bar key={s.id} dataKey={s.id} name={s.name} stackId="pk" fill={COLORS[i % COLORS.length]} radius={i === series.length - 1 ? [4, 4, 0, 0] : 0} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </SectionCard>
  );
}
